import {Component} from '@angular/core';
/**
 * \@title Basic sidenav
 */
export class SidenavOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sidenav-overview-example',
  templateUrl: 'sidenav-overview-example.html',
  styleUrls: ['sidenav-overview-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SidenavOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
SidenavOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidenavOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
